module.exports = __webpack_public_path__ + "static/media/dust.51268735.svg";